module.exports = __webpack_public_path__ + "files/7e772e624f0f197bee95d7e561ffff8a.png";